const ABHintCore = require("../core/ABHintCore");
module.exports = class ABHint extends ABHintCore {};
